import { Typography } from '@mui/material';
import { DescriptionContainer } from './styles';
import { useEffect } from 'react';
import api from '../../api';
import { useDispatch, useSelector } from 'react-redux';
import { setDescriptionText } from '../../redux/modelDataSlice';
import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

const Description = () => {
	const defaultMappingName = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const designDefinition = useSelector(state => state.designDefinition.partDefinition);
	const dispatch = useDispatch();
	const descriptionText = useSelector(state => state.modelData.descriptionText);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				if (designDefinition.longDescription) {
					const fetchedData = await api.gainLongDescription(defaultMappingName);
					dispatch(setDescriptionText(fetchedData));
				}
				setLoading(false);
			} catch (err) {
				console.error(err);
			}
		};
		fetchData();
	}, [dispatch, defaultMappingName, designDefinition.longDescription]);

	return (
		!loading && (
			<DescriptionContainer>
				<Typography variant="body1" component="p">
					{ReactHtmlParser(descriptionText)}
				</Typography>
			</DescriptionContainer>
		)
	);
};

export default Description;
